export class VerifyPathError extends Error {
    constructor(
        message: string,
        public status: number,
        public needRedirect = false,
        public newUrl?: string,
        public queries: { [key: string]: string } = {},
        public replace = false
    ) {
        super(message);
    }
}

export enum ReserveType {
    Flight = 'flight',
    Train = 'train',
    Bus = 'bus',
    Taxi = 'taxi',
    Hotel = 'hotel',
    Ship = 'ship',
    TrainTour = 'train-tour',
    Bundle = 'bundle',
}

export interface ItineraryPathData {
    adultCount?: string;
    childCount?: string;
    infantCount?: string;
    [x: string]: string | undefined;
}
export interface ItineraryParams {}

export class RequestCanceledException extends Error {
    requestWasCanceled = true;
    requestAlreadyLoaded = false;
}

/**
 * Type of calendar
 */
export enum CalendarType {
    Jalali = 'jalali',
    Gregorian = 'gregory',
}

export enum AutoReserveType {
    None = 'none',
    Item = 'item',
    Route = 'route',
}
